import Organisation from 'actions/organisation';

export default Organisation.createReducer();